import { __module as v } from "../../../_virtual/logger2.js";
/*!
 * js-logger - http://github.com/jonnyreeves/js-logger
 * Jonny Reeves, http://jonnyreeves.co.uk/
 * js-logger may be freely distributed under the MIT license.
 */
var R = v.exports, E;
function F() {
  return E ? v.exports : (E = 1, function(d) {
    (function(g) {
      var n = {};
      n.VERSION = "1.6.1";
      var m, c = {}, f = function(e, t) {
        return function() {
          return t.apply(e, arguments);
        };
      }, h = function() {
        var e = arguments, t = e[0], a, o;
        for (o = 1; o < e.length; o++)
          for (a in e[o])
            !(a in t) && e[o].hasOwnProperty(a) && (t[a] = e[o][a]);
        return t;
      }, u = function(e, t) {
        return { value: e, name: t };
      };
      n.TRACE = u(1, "TRACE"), n.DEBUG = u(2, "DEBUG"), n.INFO = u(3, "INFO"), n.TIME = u(4, "TIME"), n.WARN = u(5, "WARN"), n.ERROR = u(8, "ERROR"), n.OFF = u(99, "OFF");
      var L = function(e) {
        this.context = e, this.setLevel(e.filterLevel), this.log = this.info;
      };
      L.prototype = {
        // Changes the current logging level for the logging instance.
        setLevel: function(e) {
          e && "value" in e && (this.context.filterLevel = e);
        },
        // Gets the current logging level for the logging instance
        getLevel: function() {
          return this.context.filterLevel;
        },
        // Is the logger configured to output messages at the supplied level?
        enabledFor: function(e) {
          var t = this.context.filterLevel;
          return e.value >= t.value;
        },
        trace: function() {
          this.invoke(n.TRACE, arguments);
        },
        debug: function() {
          this.invoke(n.DEBUG, arguments);
        },
        info: function() {
          this.invoke(n.INFO, arguments);
        },
        warn: function() {
          this.invoke(n.WARN, arguments);
        },
        error: function() {
          this.invoke(n.ERROR, arguments);
        },
        time: function(e) {
          typeof e == "string" && e.length > 0 && this.invoke(n.TIME, [e, "start"]);
        },
        timeEnd: function(e) {
          typeof e == "string" && e.length > 0 && this.invoke(n.TIME, [e, "end"]);
        },
        // Invokes the logger callback if it's not being filtered.
        invoke: function(e, t) {
          m && this.enabledFor(e) && m(t, h({ level: e }, this.context));
        }
      };
      var r = new L({ filterLevel: n.OFF });
      (function() {
        var e = n;
        e.enabledFor = f(r, r.enabledFor), e.trace = f(r, r.trace), e.debug = f(r, r.debug), e.time = f(r, r.time), e.timeEnd = f(r, r.timeEnd), e.info = f(r, r.info), e.warn = f(r, r.warn), e.error = f(r, r.error), e.log = e.info;
      })(), n.setHandler = function(e) {
        m = e;
      }, n.setLevel = function(e) {
        r.setLevel(e);
        for (var t in c)
          c.hasOwnProperty(t) && c[t].setLevel(e);
      }, n.getLevel = function() {
        return r.getLevel();
      }, n.get = function(e) {
        return c[e] || (c[e] = new L(h({ name: e }, r.context)));
      }, n.createDefaultHandler = function(e) {
        e = e || {}, e.formatter = e.formatter || function(i, l) {
          l.name && i.unshift("[" + l.name + "]");
        };
        var t = {}, a = function(o, i) {
          Function.prototype.apply.call(o, console, i);
        };
        return typeof console > "u" ? function() {
        } : function(o, i) {
          o = Array.prototype.slice.call(o);
          var l = console.log, s;
          i.level === n.TIME ? (s = (i.name ? "[" + i.name + "] " : "") + o[0], o[1] === "start" ? console.time ? console.time(s) : t[s] = (/* @__PURE__ */ new Date()).getTime() : console.timeEnd ? console.timeEnd(s) : a(l, [s + ": " + ((/* @__PURE__ */ new Date()).getTime() - t[s]) + "ms"])) : (i.level === n.WARN && console.warn ? l = console.warn : i.level === n.ERROR && console.error ? l = console.error : i.level === n.INFO && console.info ? l = console.info : i.level === n.DEBUG && console.debug ? l = console.debug : i.level === n.TRACE && console.trace && (l = console.trace), e.formatter(o, i), a(l, o));
        };
      }, n.useDefaults = function(e) {
        n.setLevel(e && e.defaultLevel || n.DEBUG), n.setHandler(n.createDefaultHandler(e));
      }, n.setDefaults = n.useDefaults, d.exports ? d.exports = n : (n._prevLogger = g.Logger, n.noConflict = function() {
        return g.Logger = n._prevLogger, n;
      }, g.Logger = n);
    })(R);
  }(v), v.exports);
}
export {
  F as __require
};
//# sourceMappingURL=logger.js.map
